// removed by extract-text-webpack-plugin
module.exports = {"buttonRemove":"_1mexsorYL_ekyURzisimVu"};


//////////////////
// WEBPACK FOOTER
// ./app/dialogs/BundleEdit/style.scss
// module id = 1068
// module chunks = 0